import type { DayPart } from "./shared/timeOffTypes";

/**
 * Number of days a request represents, for reporting purposes (e.g. the
 * By person chart on the Org-wide tab). Mirrors the weekday-only logic in
 * src/lib/server/forecast.ts's buildWeekdayMinutes: weekends don't count
 * (nobody should read "took a week of vacation" from a Fri-Mon request as
 * more than 2 days), and a half-day request is worth 0.5 regardless of how
 * many calendar days it spans.
 */
export function requestDurationDays(startDate: string, endDate: string, dayPart: DayPart): number {
  const perDay = dayPart === "full" ? 1 : 0.5;

  const cursor = new Date(`${startDate.slice(0, 10)}T00:00:00Z`);
  const end = new Date(`${endDate.slice(0, 10)}T00:00:00Z`);

  let weekdayCount = 0;
  while (cursor <= end) {
    const dow = cursor.getUTCDay();
    if (dow !== 0 && dow !== 6) weekdayCount++;
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }

  return weekdayCount * perDay;
}
